import script from "./ReleaseNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./ReleaseNotes.vue?vue&type=script&setup=true&lang=js"

import "./ReleaseNotes.vue?vue&type=style&index=0&id=1a3e2b0c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a3e2b0c"]])

export default __exports__